import LoadingScreen from 'components/atoms/loading-screen/LoadingScreen'
import NoDataBoundary from 'components/atoms/no-data-boundary/NoDataBoundary';
import PendingsChart from 'components/organisms/statistics/AllCharts/PendingsChart';
import { customStyles } from 'lib/helpers/configs/customStyles';
import { useWidgetData } from 'lib/hooks/queries/Dashboard/useWidgetData';
import React, { FC, useMemo, useState } from 'react'
import { useTranslation } from 'react-i18next';
import CreatableSelect from 'react-select/creatable';

interface Props {
    name: string;
    api: string;
    type: string;
}


const StatisticChartWidget: FC<Props> = ({ name, api, type }) => {

    const { t } = useTranslation();

    const [Filter, setFilter] = useState('This week')

    const { data, isLoading } = useWidgetData({ endpoint: api, params: { filter_on: Filter }, type: name })

    const [hoveredSlice, setHoveredSlice] = useState<string | null>(null);

    const FormattedData = useMemo(() => {
        return (data as any)?.data
    }, [data])

    const FormatCategorieName = (item: any) => {

        return item
            .split('_')
            .map((word: string) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
            .join(' ')

    }

    if (isLoading) return <LoadingScreen />

    return (
        <div className='w-full h-full bg-white border border-[#F2F4F7] rounded-2xl p-5'>
            <div className='pb-5 flex items-center gap-4 justify-between'>
                <div className='text-primaryTextColor font-inter-bold xl:text-lg 2xl:text-xl'>
                    {t(name)}
                </div>
                <div>
                    <CreatableSelect<any, false>
                        options={[
                            { value: "Today", label: t("Today") },
                            { value: "This week", label: t("This week") },
                            { value: "This month", label: t("This month") },
                        ]}
                        value={{
                            value: Filter,
                            label: t(Filter)
                        }}
                        className="cursor-pointer font-inter-regular react-select-container 3xl:min-w-[150px]"
                        classNamePrefix="react-select"
                        onChange={(newValue: any, actionMeta: any) => {
                            if (
                                actionMeta.action === "select-option" &&
                                newValue?.value
                            ) {
                                setFilter(newValue.value)
                            }
                        }}
                        styles={customStyles}
                        isValidNewOption={() => false}
                        menuPosition={"fixed"}
                        menuPortalTarget={document.body}
                    />
                </div>
            </div>
            <div className="flex flex-col gap-20 items-center md:flex-row relative">
                <NoDataBoundary
                    condition={FormattedData && FormattedData?.length > 0}
                    fallback={
                        <p className="text-[#7D8592] font-inter-regular mx-auto my-20 flex justify-center">
                            {t("There is no")} data {t("in this section.")}
                        </p>
                    }
                >
                <div className="basis-1/3">
                    <PendingsChart
                        setHoveredSlice={setHoveredSlice}
                        data={
                            Object.keys(FormattedData).map((key) => {
                                return {
                                    name: FormatCategorieName(key),
                                    y: FormattedData[key] / (FormattedData['total'] * 100),
                                    z: 100
                                }
                            })}
                    />
                </div>

                <div className="basis-2/3">
                    <div className="grid-cols-2 grid gap-2">
                        {Object.keys(FormattedData).map((key, index) => {
                            const item = {
                                status: FormatCategorieName(key),
                                count: FormattedData[key],
                            };
                            return (
                                <div
                                    onMouseEnter={() => setHoveredSlice(FormattedData[key])}
                                    onMouseLeave={() => setHoveredSlice(null)}
                                    key={index}
                                    className={`flex justify-between gap-3 items-center transition-colors rounded-[8px] py-[8px] px-[20px]
                                    ${item.status === 'Total' ? 'col-span-2' : 'col-span-1'} ${item.status === hoveredSlice
                                            ? 'text-white bg-[#EFBE12] border-[#EFBE12]'
                                            : 'text-primaryTextColor border border-[#F2F4F7]'} `
                                    }>
                                    <div className="font-inter-medium">
                                        {t(item.status)}
                                    </div>
                                    <div className="font-inter-bold">
                                        {item.count}
                                    </div>
                                </div>
                            )

                        })}
                    </div>
                </div>
                </NoDataBoundary>
            </div>
        </div >

    )
}

export default StatisticChartWidget